export enum MESSAGE_STATE {
  DELIVERED = 1,
  QUEUED = 2,
  FAILED = 3,
  SENT = 4
}
